import React, { useState } from 'react';
import toast from 'react-hot-toast';
import api from '../../utils/api';

const B = '#0B3D6E', T = '#0F6E56';

export default function Contact({ lang }) {
  const fr = lang === 'fr';
  const [form, setForm] = useState({ name:'', email:'', phone:'', company:'', subject:'', message:'' });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);

  const subjects = fr
    ? ['Demande de devis','Demande commerciale','Appel d\'offre','Support / réclamation','Partenariat','Autre']
    : ['Quote request','Commercial inquiry','Tender request','Support / complaint','Partnership','Other'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name||!form.email||!form.message) { toast.error(fr?'Veuillez remplir tous les champs':'Please fill all fields'); return; }
    setSending(true);
    try {
      await api.post('/contact', form);
      setSent(true);
      toast.success(fr?'Message envoyé ! Nous vous répondrons sous 24h.':'Message sent! We will reply within 24h.');
      setForm({ name:'', email:'', phone:'', company:'', subject:'', message:'' });
    } catch(err) {
      toast.error(err.response?.data?.message || (fr?'Erreur lors de l\'envoi':'Send error'));
    } finally { setSending(false); }
  };

  const inp = { width:'100%', border:'1px solid #e2e8f0', borderRadius:8, padding:'10px 12px', fontSize:13, background:'#f8fafc', color:'#1a2535', outline:'none', fontFamily:'inherit', boxSizing:'border-box' };
  const lbl = { display:'block', fontSize:11, fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.5px', marginBottom:5 };

  const infos = [
    { icon:'📍', label:fr?'Adresse':'Address', value:'Quartier El Badr, Casablanca 20250' },
    { icon:'📞', label:fr?'Téléphone':'Phone', value:'+212 600 000 000' },
    { icon:'✉️', label:'Email', value:'contact@lomedmedicare.ma' },
    { icon:'🕐', label:fr?'Horaires':'Hours', value:fr?'Lun–Sam : 8h–18h':'Mon–Sat: 8am–6pm' },
  ];

  const contactSchema = {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    name: fr ? 'Contact LOMED MEDICARE — Demande de devis' : 'Contact LOMED MEDICARE — Quote request',
    description: fr ? 'Contactez LOMED MEDICARE pour une demande de devis ou d\'information sur nos dispositifs médicaux au Maroc.' : 'Contact LOMED MEDICARE for a quote request or information about our medical devices in Morocco.',
    url: 'https://lomedmedicare.com/contact',
    mainEntity: {
      '@type': 'Organization',
      name: 'LOMED MEDICARE',
      telephone: '+212-600-000000',
      email: 'contact@lomedmedicare.ma',
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Quartier El Badr',
        addressLocality: 'Casablanca',
        postalCode: '20250',
        addressCountry: 'MA',
      },
    },
  };

  return (
    <div style={{ maxWidth:960, margin:'0 auto', padding:'1rem' }}>

      
        <title>{fr
          ? 'Contact & Devis — LOMED MEDICARE | Dispositifs Médicaux Maroc'
          : 'Contact & Quote — LOMED MEDICARE | Medical Devices Morocco'}</title>
        <meta name="description" content={fr
          ? "Contactez LOMED MEDICARE pour un devis gratuit sur vos dispositifs médicaux. Équipe commerciale disponible lun–sam 8h–18h. Réponse sous 24h. Casablanca, Maroc."
          : "Contact LOMED MEDICARE for a free quote on your medical devices. Sales team available Mon–Sat 8am–6pm. Reply within 24h. Casablanca, Morocco."} />
        <meta name="keywords" content={fr
          ? 'contact LOMED MEDICARE, devis dispositifs médicaux Maroc, commercial médical Casablanca, demande devis matériel médical'
          : 'contact LOMED MEDICARE, medical devices quote Morocco, medical sales Casablanca'} />
        <link rel="canonical" href="https://lomedmedicare.com/contact" />
        <meta property="og:title" content={fr ? 'Contact LOMED MEDICARE — Devis gratuit' : 'Contact LOMED MEDICARE — Free quote'} />
        <meta property="og:description" content={fr ? 'Réponse sous 24h. Équipe commerciale disponible lun–sam.' : 'Reply within 24h. Sales team available Mon–Sat.'} />
        <meta property="og:url" content="https://lomedmedicare.com/contact" />
        <script type="application/ld+json">{JSON.stringify(contactSchema)}</script>
      

      <div style={{ fontSize:11, fontWeight:600, textTransform:'uppercase', letterSpacing:'1px', color:T, marginBottom:4 }}>{fr?'Nous contacter':'Contact us'}</div>
      <h1 style={{ fontSize:20, fontWeight:700, marginBottom:6 }}>{fr ? 'LOMED MEDICARE — Demande de devis' : 'LOMED MEDICARE — Quote request'}</h1>
      <p style={{ fontSize:13, color:'#64748b', marginBottom:'1.5rem' }}>{fr?'Équipe commerciale disponible du lundi au samedi de 8h à 18h — Réponse garantie sous 24h':'Sales team available Monday to Saturday, 8am–6pm — Response guaranteed within 24h'}</p>

      <div style={{ display:'grid', gap:16 }} className="contact-layout">
        <style>{`.contact-layout{grid-template-columns:260px 1fr}@media(max-width:700px){.contact-layout{grid-template-columns:1fr !important}}`}</style>

        {/* Left */}
        <div style={{ display:'flex', flexDirection:'column', gap:12 }}>
          <div style={{ background:`linear-gradient(135deg,${B},${T})`, borderRadius:12, padding:'1.5rem', color:'#fff', position:'relative', overflow:'hidden' }}>
            <img src="https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=400&q=40" alt="LOMED MEDICARE Casablanca" loading="lazy" style={{ position:'absolute', inset:0, width:'100%', height:'100%', objectFit:'cover', opacity:0.1 }}/>
            <div style={{ position:'relative', zIndex:1 }}>
              <h2 style={{ fontSize:15, fontWeight:600, marginBottom:'1.2rem' }}>{fr?'Coordonnées':'Contact details'}</h2>
              {infos.map(info=>(
                <div key={info.label} style={{ display:'flex', gap:10, marginBottom:14 }}>
                  <span style={{ fontSize:16, flexShrink:0 }}>{info.icon}</span>
                  <div>
                    <div style={{ fontSize:10, opacity:0.65, marginBottom:1 }}>{info.label}</div>
                    <div style={{ fontSize:13 }}>{info.value}</div>
                  </div>
                </div>
              ))}
              {/* WhatsApp */}
              <a href="https://wa.me/212600000000" target="_blank" rel="noreferrer" style={{ display:'flex', alignItems:'center', gap:8, background:'#25D366', color:'#fff', padding:'9px 14px', borderRadius:9, fontSize:12, fontWeight:600, textDecoration:'none', marginTop:8 }}>
                <svg viewBox="0 0 24 24" style={{ width:15, height:15, fill:'#fff', flexShrink:0 }}><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                WhatsApp
              </a>
            </div>
          </div>

          <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'1rem' }}>
            <div style={{ fontSize:11, fontWeight:600, color:'#64748b', textTransform:'uppercase', letterSpacing:'0.8px', marginBottom:10 }}>{fr?'Liens rapides':'Quick links'}</div>
            {[[fr?'Demander un devis':'Request a quote','/devis'],[fr?'Voir le catalogue':'View catalogue','/catalogue'],[fr?'À propos de nous':'About us','/about'],[fr?'StockMed SaaS':'StockMed SaaS','/stock']].map(([l,to])=>(
              <a key={to} href={to} style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #f1f5f9', fontSize:13, color:'#64748b', textDecoration:'none' }}>
                {l}<span style={{ color:'#cbd5e1' }}>›</span>
              </a>
            ))}
          </div>

          {/* Mentions légales mini */}
          <div style={{ background:'#f8fafc', border:'1px solid #e2e8f0', borderRadius:10, padding:'12px', fontSize:11, color:'#94a3b8', lineHeight:1.7 }}>
            <strong style={{ color:'#475569', display:'block', marginBottom:4 }}>LOMED MEDICARE</strong>
            RC : XXXXXXX<br/>
            ICE : XXXXXXXXXXXXXXX<br/>
            IF : XXXXXXXXX<br/>
            Casablanca 20250, Maroc 🇲🇦
          </div>
        </div>

        {/* Right — form */}
        <div>
          {sent ? (
            <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'3rem', textAlign:'center', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
              <div style={{ width:64, height:64, background:'#E1F5EE', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:28, margin:'0 auto 16px' }}>✅</div>
              <h2 style={{ fontSize:18, fontWeight:700, color:'#0F6E56', marginBottom:8 }}>{fr?'Message envoyé !':'Message sent!'}</h2>
              <p style={{ fontSize:13, color:'#64748b', lineHeight:1.7, marginBottom:20 }}>{fr?'Merci pour votre message. Notre équipe commerciale vous répondra dans les 24 heures.':'Thank you for your message. Our team will reply within 24 hours.'}</p>
              <button onClick={()=>setSent(false)} style={{ background:B, color:'#fff', border:'none', padding:'10px 24px', borderRadius:8, fontSize:13, cursor:'pointer', fontWeight:600 }}>
                {fr?'Envoyer un autre message':'Send another message'}
              </button>
            </div>
          ) : (
            <div style={{ background:'#fff', border:'1px solid #e2e8f0', borderRadius:12, padding:'1.5rem', boxShadow:'0 1px 4px rgba(0,0,0,0.07)' }}>
              <h2 style={{ fontSize:15, fontWeight:700, marginBottom:16, paddingBottom:12, borderBottom:'1px solid #f1f5f9' }}>{fr?'Demande de devis ou d\'information':'Quote or information request'}</h2>
              <form onSubmit={handleSubmit} style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14 }} className="cf-grid">
                  <style>{`@media(max-width:500px){.cf-grid{grid-template-columns:1fr !important}}`}</style>
                  <div>
                    <label style={lbl}>{fr?'Nom complet *':'Full name *'}</label>
                    <input style={inp} value={form.name} onChange={e=>setForm({...form,name:e.target.value})} placeholder={fr?'Dr. Mohamed El...':'Dr. Mohamed...'} required/>
                  </div>
                  <div>
                    <label style={lbl}>Email *</label>
                    <input type="email" style={inp} value={form.email} onChange={e=>setForm({...form,email:e.target.value})} placeholder={fr?'contact@clinique.ma':'contact@clinic.ma'} required/>
                  </div>
                  <div>
                    <label style={lbl}>{fr?'Téléphone':'Phone'}</label>
                    <input style={inp} value={form.phone} onChange={e=>setForm({...form,phone:e.target.value})} placeholder="+212 6XX XXX XXX"/>
                  </div>
                  <div>
                    <label style={lbl}>{fr?'Établissement':'Institution'}</label>
                    <input style={inp} value={form.company} onChange={e=>setForm({...form,company:e.target.value})} placeholder={fr?'Clinique, Hôpital...':'Clinic, Hospital...'}/>
                  </div>
                </div>
                <div>
                  <label style={lbl}>{fr?'Objet':'Subject'}</label>
                  <select style={inp} value={form.subject} onChange={e=>setForm({...form,subject:e.target.value})}>
                    <option value="">{fr?'Choisir un objet...':'Select a subject...'}</option>
                    {subjects.map(s=><option key={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label style={lbl}>{fr?'Message *':'Message *'}</label>
                  <textarea style={{ ...inp, minHeight:130, resize:'vertical' }} value={form.message} onChange={e=>setForm({...form,message:e.target.value})} placeholder={fr?'Décrivez votre besoin, volume estimé...':'Describe your need, estimated volume...'} required/>
                </div>
                <button type="submit" disabled={sending} style={{ background:sending?'#94a3b8':`linear-gradient(135deg,${B},${T})`, color:'#fff', border:'none', padding:'12px', borderRadius:8, fontSize:14, fontWeight:600, cursor:'pointer', opacity:sending?0.7:1 }}>
                  {sending?(fr?'Envoi en cours...':'Sending...'):(fr?'📋 Envoyer ma demande →':'📋 Send my request →')}
                </button>
              </form>
              <div style={{ marginTop:14, background:'#E1F5EE', border:'1px solid #9FE1CB', borderRadius:10, padding:'10px 12px', display:'flex', gap:8 }}>
                <span style={{ fontSize:15 }}>ℹ️</span>
                <div style={{ fontSize:12, color:T, lineHeight:1.65 }}>
                  {fr?'Réponse garantie sous 24h. Pour les urgences, contactez-nous sur WhatsApp.':'Response guaranteed within 24h. For urgent matters, contact us on WhatsApp.'}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

